import { render, staticRenderFns } from "./compass.vue?vue&type=template&id=9cab76f2&scoped=true&"
import script from "./compass.vue?vue&type=script&lang=js&"
export * from "./compass.vue?vue&type=script&lang=js&"
import style0 from "./compass.vue?vue&type=style&index=0&id=9cab76f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cab76f2",
  null
  
)

export default component.exports